<template>
  <Companies :menuItem="this.menuItem"></Companies>
</template>

<script>
import Companies from "@/components/Companies.vue";

export default {
  name: "Favorites",
  data() {
    return {
      menuItem: "favorites",
    };
  },
  components: {
    Companies,
  },
  methods: {
    setCurrentPage(page) {
      this.$parent.setCurrentPage(page);
    },
  }
};
</script>

<style scoped></style>
